import React from 'react'
import ProductCard from '@components/molecules/ProductCard'
import { SearchProps } from '@interfaces/search'

const Search: React.FC<SearchProps> = ({ products = [], query = '' }) => {
  if (products.length === 0) {
    return (
      <div className="flex items-center justify-center fade-in">
        <p className="body-lg text-black">{window.DEPT.Strings.search.noProductsFound}</p>
      </div>
    )
  }
  return (
    <div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} className="min-w-40 max-w-40 md:min-w-60 md:max-w-60" />
        ))}
      </div>
      <div className="flex items-center justify-center pt-8">
        <a
          href={`/search?q=${encodeURIComponent(query)}`}
          className="block body-sm text-blue-2 fade-in hover:underline"
          aria-label="See all results"
        >
          See all results
        </a>
      </div>
    </div>
  )
}

export default Search
